import React from 'react';
import {
  Card, Badge,
  CardBody, CardFooter, Row, Col,
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem 
 } from "reactstrap";

 
import './styles.css';

var reports = require('../reports/NotebookToolReport');

var Utils = require ('Utils');

const courseActions = ( token, calendarID, courseID) => {
  return (
    <UncontrolledDropdown 
          // className="btn-rotate"
           >
        <DropdownToggle
          // aria-haspopup={true}
          caret
          color="default"
          data-toggle="dropdown"
          id="navbarDropdownMenuLink"
        >
          Acciones
        </DropdownToggle>
        <DropdownMenu
          persist
          aria-labelledby="navbarDropdownMenuLink"
          left
        >
                <DropdownItem href={"/admin/course/"+courseID+"/attendance"} >
                  Asistencias
                </DropdownItem>
                <DropdownItem href={"/admin/course/"+courseID+"/calif"} >
                  Calificaciones
                </DropdownItem>
                <DropdownItem href={"/admin/course/"+courseID} >
                  Administrar Curso
                </DropdownItem>
                <DropdownItem 
                    href="#inicio"
                    onClick={ () => reports.downloadReport(token, calendarID, courseID, 'UYU26793-106f-11ec-8e37-069175aa36ca','1er Informe Bimestral')} >
                  1er Informe Bimestral
                </DropdownItem>
                <DropdownItem 
                    href="#inicio"
                    onClick={ () => reports.downloadReport(token, calendarID, courseID, 'UYU26793-106f-11ec-8e37-06917segundo','2do Informe Bimestral')} >
                  2do Informe Bimestral
                </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
  )
}

const CourseCard = ( { course, calendarID, token } ) =>  {
        
    return (
              <Card
                className={ "cover-image-card"}
                >
              <CardBody>
                <Row>
                  <Col md="12" >
                      <p className="curso">{Utils.capitalize(course.name)}</p>
                      <p className="turno">Turno {course.shift_name}</p>
                  </Col>

                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                  <div class="float-right">
                     { courseActions( token, calendarID, course.course_id ) }
                  </div>
                  {course.att_validated!=='Y'&&
                  <Badge style={{ backgroundColor: "red" }}>cargar inasistencias</Badge>
                  }
              </CardFooter>
            </Card>

            )
  };

export { CourseCard } ;
